<template>
  <header class="bg-red-600 p-2">
    <nav class="mx--auto flex items-center justify-between" aria-label="Global">
      <div class="flex w-full">
        <RouterLink to="/">
          <img alt="FFE Logo" class="w-16" src="@/assets/logo.svg" />
        </RouterLink>
        <div class="m-auto ml-0 text-3xl font-extrabold text-stone-800">
          Feuerlöscher Überprüfung
        </div>
        <div class="mr-4 text-xl font-black text-stone-800">
          {{ dateFormat.format(dataStore.date) }}
        </div>
      </div>
      <RouterLink to="settings">
        <img alt="Settings" class="w-12 invert" src="@/assets/settings.svg" />
      </RouterLink>
    </nav>
  </header>
</template>

<script setup lang="ts">
import { useStore } from "../stores/dataStore";
const dataStore = useStore();
const dateFormat = new Intl.DateTimeFormat("de");
</script>

<style scoped></style>
